type Props = {
    page: number;        // 0-based
    size: number;
    total: number;
    onPage: (next: number) => void;
    className?: string;
};

/** Standard previous/next bar with “Showing X to Y of Z” */
export default function TablePagination({
                                            page,
                                            size,
                                            total,
                                            onPage,
                                            className = "",
                                        }: Props) {

    const start = page * size + (total ? 1 : 0);
    const end = Math.min(total, page * size + size);
    const hasPrev = page > 0;
    const hasNext = (page + 1) * size < total;

    return (
        <nav
            aria-label="Pagination"
            className={`flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 ${className}`}
        >
            <div className="hidden sm:block">
                <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{start || 0}</span> to{" "}
                    <span className="font-medium">{end || 0}</span> of{" "}
                    <span className="font-medium">{total}</span> results
                </p>
            </div>
            <div className="flex flex-1 justify-between sm:justify-end">
                <button
                    type="button"
                    onClick={() => onPage(page - 1)}
                    disabled={!hasPrev}
                    className="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    Previous
                </button>
                <button
                    type="button"
                    onClick={() => onPage(page + 1)}
                    disabled={!hasNext}
                    className="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    Next
                </button>
            </div>
        </nav>
    );
}
